var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadsetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 29.257,
    viewBox: "0 0 27 29.257",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-headset",
    "data-name": "Icon ionic-md-headset",
    d: "M18,3.375A13.683,13.683,0,0,0,4.5,17.234V28.012A4.558,4.558,0,0,0,9,32.632h4.5V20.25h-6V17.234A10.638,10.638,0,0,1,18,6.455,10.633,10.633,0,0,1,28.5,17.234V20.25h-6V32.625H27a4.553,4.553,0,0,0,4.5-4.62V17.234A13.683,13.683,0,0,0,18,3.375Z",
    transform: "translate(-4.5 -3.375)",
    fill: "#23b458"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadsetIcon);
export default __webpack_public_path__ + "static/media/headset_icon.0ca720fc04ac2611c78a1865916c1938.svg";
export { ForwardRef as ReactComponent };